export const CHECKOUT_OTP_PAGE_TEST_ID = {
  submitButton: 'email-address-submit',
  passcode: 'passcode',
};
